import api from "../../utils/api";
import {
    PERMISSIONS_LOADED, API_CALL_FAILED
} from "../types";

export const list = () => async (dispatch) => {
    try {
        const res = await api.get(`/permissions`);
        return res.data;
    } catch (err) {
        dispatch({
            type: API_CALL_FAILED,
            payload: { ...err }
        });
    }
}

export const mine = () => async (dispatch) => {
    try {
        const res = await api.get(`/permissions/me`);
        dispatch({
            type: PERMISSIONS_LOADED,
            payload: res.data
        });
        return res.data;
    } catch (err) {
        dispatch({
            type: API_CALL_FAILED,
            payload: { ...err }
        });
    }
}
